import React from 'react';
import Navbar from '../components/Navbar';
import Orders from '../components/Orders';
import Footer from '../components/Footer'

export default function OrderPage() {
  return (
    <>
        <Navbar></Navbar>
        <Orders></Orders>
        <Footer></Footer>
    </>
  )
}
